import { GroupedWeeklySchedule } from '../../../../db/courses/types';
import { format24hTo12hTime } from '../../../../utils/datetime';

export type VMProps = GroupedWeeklySchedule;

export default function useWeeklyScheduleVM({ days, endTime, startTime }: VMProps) {
  const timing = `${format24hTo12hTime(startTime)} - ${format24hTo12hTime(endTime)}`;
  return { days, timing };
}
